import React from 'react';
import { useLocation } from 'react-router-dom';
import Typography from '@mui/material/Typography';
import { useNavigate } from "react-router-dom";

export default function NavItem({ path, text, local, navItemStyle }) {
  const navigate = useNavigate();
  const handleNavigate = () => {
    if (local) {
      navigate(path);
    } else {
      window.location.assign(path);
    }
  };
  const location = useLocation();
  const isActualLocation = path === location.pathname;
  const sx = navItemStyle(isActualLocation)
  return (
    <Typography variant="h6" component="div" sx={sx} onClick={handleNavigate} >
      {text}
    </Typography>
  );
}